// AlertDialogComponent.tsx
import React from 'react'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react'

interface AlertDialogComponentProps {
  isOpen: boolean
  onClose: () => void
  onDelete: () => void
  cancelRef: React.RefObject<HTMLButtonElement>
}

const AlertDialogComponent: React.FC<AlertDialogComponentProps> = ({
  isOpen,
  onClose,
  onDelete,
  cancelRef,
}) => (
  <AlertDialog
    isOpen={isOpen}
    leastDestructiveRef={cancelRef}
    onClose={onClose}
  >
    <AlertDialogOverlay>
      <AlertDialogContent>
        <AlertDialogHeader fontSize="lg" fontWeight="bold">
          Delete Content Block
        </AlertDialogHeader>
        <AlertDialogBody>
          Are you sure you want to delete this content block? This action cannot
          be undone.
        </AlertDialogBody>
        <AlertDialogFooter>
          <Button ref={cancelRef} onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="red" onClick={onDelete} ml={3}>
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialogOverlay>
  </AlertDialog>
)

export default AlertDialogComponent
